// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var EmailHandlingController = function ($scope, $http, $location, $routeParams, $window, Email, Customer, $rootScope) {
    $scope.triggered = false;
    $scope.updateCustomer = false;
    $scope.updateCustomerDisabled = false;
    $scope.newEmailAddress = '';
    $scope.documentName = null;

    $scope.customer = null;
    $scope.email = Email.get({ id: $routeParams.emailId },
        function (email) {
            if (email) {               
                $scope.newEmailAddress = email.To[0].Address;
            }
            if (!email || !email.CustomerId) return;
            if (email.Attachments && email.Attachments.length > 0)
                $scope.documentName = email.Attachments[0].FileName;
            Customer.get({ customerId: email.CustomerId },
                function (customer) {
                    $scope.customer = customer;                  
                    $scope.checkUpdateCustomer();
                });
        });

    $scope.checkUpdateCustomer = function () {
        $scope.updateCustomer = $scope.email && $scope.email.To[0].Address != $scope.newEmailAddress;
        $scope.updateCustomerDisabled = !$scope.email || $scope.email.To[0].Address == $scope.newEmailAddress;
    }
    $scope.resend = function () {
        if ($scope.triggered)
            return;
        $scope.triggered = true;
        $http({
            method: "POST", url: "/api/v1/emails/" + $routeParams.emailId + "/resend", params: null,
            data: { NewEmailAddress: $scope.newEmailAddress, OldEmailAddress: $scope.email.To[0].Address, UpdateCustomer: $scope.updateCustomer }, headers: { "Content-Type": "application/json" }, cache: false
        }).then(function () {
            $location.path("/logs/emails");
        }, function () {
            $scope.triggered = false;
        });
    };
    $scope.back = function () {
        $window.history.back();
    }
};
EmailHandlingController.$inject = ['$scope', '$http', '$location', '$routeParams', '$window', 'Email', 'Customer', '$rootScope'];
